import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components/index";
import GoogleMapReact from "google-map-react";
import API from "@beardeddevops/react.api";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Select from "react-select";
import Home from "@material-ui/icons/Home"
import {Circle} from '@react-google-maps/api'
import {Button} from "reactstrap";
import {Call_Geocode_API} from "../../constants/Utilities";
import {getGoogleMapBootstrapURLKeys} from "../../constants/GoogleMaps";
const userColors = ["#FF0000", "#673ab7", "#ff9800", "#025E05",
	"#03a9f4", "#A00000", "#4caf50", "#8bc34a", "#cddc39",
	"#ff5722", "#9c27b0", "#795548", "#3f51b5", "#607d8b",
	"#000000", "#FF0000", "#673ab7", "#ff9800", "#025E05",
	"#03a9f4", "#A00000", "#4caf50", "#8bc34a", "#cddc39",
	"#ff5722", "#9c27b0", "#795548", "#3f51b5", "#607d8b",
	"#000000"]


const PinLocation = ({pkey, text, icon}) => {
	return (
		<div style={{textAlign: 'center', width: '40px', position: 'absolute', left: '-20px', height: '44px', top: '-22px'}} key={pkey}>
			{icon}
			<span style={{fontSize: '14px', lineHeight: '16px', display: 'inline-block', fontWeight: 'bold', zIndex: 999}}>{text}</span>
		</div>
	);
};

export default class FERadiusMap extends Framework.Components.Collection {
	constructor(props) {
		super(props, Types.Users._name);

		this.state.items = [];
		this.state.key = 0;

		this.state.name = '';

		this.state.users = null;
		if (localStorage.getItem('radiusmapregion')) {
			this.state.region = JSON.parse(localStorage.getItem('radiusmapregion'));
			if (!this.state.region || !this.state.region.radius) {
				this.state.region = {
					pkey: 1,
					name: "Phoenix (602, 480, 623)",
					latitude: 33.4484000,
					longitude: -112.0740000,
					radius: 60
				};
			}
		} else {
			this.state.region = {
				pkey: 1,
				name: "Phoenix (602, 480, 623)",
				latitude: 33.4484000,
				longitude: -112.0740000,
				radius: 60
			};
		}

		this.state.defaultCenter = {
			lat: 33.44838,
			lng: -112.07404
		};
		this.getCoords().then()
		this.getRegions().then()
		this.getFes().then()
		this.refreshInterval = setInterval(async () => {
			let pkeyModel = new API.BuildClass(Types.Users._name, API.RequestType.READ_ALL);
			pkeyModel.filter = {
				'filterRegion': this.state.region.pkey
			}
			let functioning = await pkeyModel.submit(null, 'GET_RADIUS_MAP');

			functioning.items.map(async (item, i) => {
				if (!functioning.items[i]['latitude'] || !functioning.items[i]['longitude']) {
					functioning.items[i]['homeLatLong'] = await this.convertAddress([item.street_1, item.city, item.state, item.zip, item.pkey])
				}
			});

			this.setState({items: functioning.items})
			this.props.setFes(functioning.items)
		}, 300000);
	}

	componentWillUnmount() {
		if (this.refreshInterval) {
			clearInterval(this.refreshInterval);
			this.refreshInterval = null;
		}
	}

	

	apiIsLoaded = (map, maps) => {
		this.state.map = map;
		this.state.maps = maps;
	};

	getCoords = async () => {
		this.setState({loading: true, items: []})
		localStorage.setItem('radiusmapregion', JSON.stringify(this.state.region))
		let pkeyModel = new API.BuildClass(Types.Users._name, API.RequestType.READ_ALL);
		pkeyModel.filter = {
			'filterRegion': this.state.region.pkey
		}
		let functioning = await pkeyModel.submit(null, 'GET_RADIUS_MAP');

		functioning.items.map(async (item, i) => {
			if (!functioning.items[i]['latitude'] || !functioning.items[i]['longitude']) {
				functioning.items[i]['homeLatLong'] = await this.convertAddress([item.street_1, item.city, item.state, item.zip, item.pkey])
			}
		});

		if (this.state.map) {
			const latLng = new this.state.maps.LatLng(this.state.region.latitude, this.state.region.longitude); // Makes a latlng
			this.state.map.panTo(latLng);
			this.state.map.setZoom(9)
		}

		this.props.setFes([])

		setTimeout(() => {
			this.setState({
				defaultCenter: {
					lat: this.state.region.latitude,
					lng: this.state.region.longitude
				},
				items: functioning.items, loading: false
			})
			this.props.setFes(functioning.items)
		}, 1500) //timeout here is to guarantee the pins are ready to be rendered

		return functioning.items;
	}

	convertAddress = async (location) => {
		if (location[0] && location[1] && location[2] && location[3]) {
			const address = (location[0] + "+" + location[1] + "+" + location[2] + "+" + location[3]).replaceAll("#", "%23");
			const response = await Call_Geocode_API(address);
			if (!response || !response?.latitude) {
				API.Toast.error(`Error getting geocoords for this address ${address}.`, {
					position: API.Toast.POSITION.TOP_CENTER,
					autoClose: 2000
				});
				return null;
			}
			let userModel = new API.BuildClass(Types.Users._name, API.RequestType.UPDATE);
			userModel.object.user = location[4];
			userModel.object.latitude = response.latitude;
			userModel.object.longitude = response.longitude;
			userModel.submit(null, "POST_COORDS", true);
			return response;
		}
		return null;
	};

	getRegions = async () => {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		model.limit = 5000;
		try {
			this.regions = await model.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				return a.name.localeCompare(b.name)
			})
			this.regions = this.regions.filter((region) => {
				return region.latitude > 0 || region.latitude < 0
			})
			this.setState({
				regions: this.regions
			});
		} catch (error) {
		}
	}

	getFes = async () => {

		let femodel = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		this.read = 'GET_CALENDAR_RESOURCES';
		femodel.limit = 5000;
		try {
			femodel.filter = {
				'filterRegions': this.state.region.pkey
			}
			this.fes = await femodel.submit(null, this.read);
			this.fes = Object.keys(this.fes).map((key) => this.fes[key]);
			this.setState({fes: this.fes[3], selectedFe: null})
		} catch (error) {
			console.log(error, 'error')
		}
	}

	panToFE = () => {
		if (this.state.selectedFe.latitude && this.state.selectedFe.longitude) {
			const latLng = new this.state.maps.LatLng(this.state.selectedFe.latitude, this.state.selectedFe.longitude); // Makes a latlng
			this.state.map.panTo(latLng);
		}
		this.state.map.setZoom(12)
	}

	render() {
		let zoom = 9;
		let extras = {};

		let object = this.state;

		return (
			<Card>
				<CardContent>
					<div>
						<div className={"table-bar"}>
							<div className={'row'}>
								<div className={'col-5'}>
									<Select
										key={this.state.regions}
										placeholder={"Region Select"}
										value={{value: this.state.region.pkey, label: this.state.region.name}}
										onChange={(value) => {
											this.setState({region: this.state.regions.find((region) => region.pkey === value.value)}, async () => {
												this.getFes().then(await this.getCoords())
											})
										}}
										options={this.state.regions?.map(region => {
											return (
												{value: region.pkey, label: region.name}
											)
										})}
										styles={{control: styles => ({...styles, lineHeight: '30px'})}}
									/>
								</div>
								<div className={'col-5'}>
									<Select
										key={this.state.fes + this.state.items}
										placeholder={"Pan To FE"}
										value={this.state.selectedFe ? {
											value: this.state.selectedFe.pkey,
											label: this.state.selectedFe.name_first + " " + this.state.selectedFe.name_last
										} : {value: null, label: "Select a FE to pan to..."}}
										onChange={(value) => {
											this.setState({selectedFe: this.state.items.find((fe) => fe.pkey === value.value)}, () => {
												this.panToFE()
											})
										}}
										options={this.state.fes?.filter((fe) => {
											if (!this.state.items) {
												return true
											}
											let currentFe = this.state.items.find(item => item.pkey === fe.resourceId)
											if (currentFe) {
												if (currentFe.latitude && currentFe.longitude) {
													return true
												}
											} else {
												return false
											}
										}).map(fe => {
											return ({value: fe.resourceId, label: fe.resourceTitle})
										})}
										styles={{control: styles => ({...styles, lineHeight: '30px'})}}
									/>
								</div>
								<div className={'col-2 text-right'}>
									<Button color={'primary'} onClick={async () => {
										await this.getCoords()
									}}>Refresh</Button>
								</div>
							</div>
						</div>
						<div style={{height: '78vh', width: '100%'}}>
							<GoogleMapReact
								bootstrapURLKeys={getGoogleMapBootstrapURLKeys()}
								defaultCenter={object.defaultCenter}
								defaultZoom={zoom}
								yesIWantToUseGoogleMapApiInternals
								onGoogleApiLoaded={({map, maps}) => this.apiIsLoaded(map, maps)}
								ref={(ref) => {
									this.mapRef = ref;
								}}
								{...extras}
							>
								<Framework.Elements.LoadingSpinner isLoading={object.loading}/>
								{object.region && object.region.latitude && object.region.radius && this.state.maps &&
									<Circle
										key={'circle_region'}
										center={new this.state.maps.LatLng(parseFloat(object.region.latitude), parseFloat(object.region.longitude))}
										radius={object.region.radius * 1609.34}
										options={{
											map: this.state.map,
											strokeColor: '#000000',
											strokeWeight: 8,
											fillOpacity: 0
										}}
										visible={true}
										draggable={false}
									/>
								}
								{object.items && object.items.map(
									(item, i) => {
										if (!item.longitude || !item.latitude) {
											return null;
										} else {
											return (
												<PinLocation
													key={i}
													zoom={zoom}
													lat={item.latitude}
													lng={item.longitude}
													text={item.name_first + " " + item.name_last}
													pkey={item.pkey}
													icon={<Home fontSize={'small'} style={{color: userColors[i]}}/>}
												/>
											)
										}
									}
								)}

								{object.items && this.state.maps && object.items.map(
									(item, i) => {
										if (!item.longitude || !item.latitude || !item.service_latitude || !item.service_longitude || !item.service_radius) {
											return null;
										} else {
											return (
												<Circle
													key={'circle' + i}
													center={new this.state.maps.LatLng(parseFloat(item.service_latitude), parseFloat(item.service_longitude))}
													radius={item.service_radius * 1609.34}
													options={{
														map: this.state.map,
														strokeColor: userColors[i],
														strokeWeight: 4,
														fillOpacity: 0
													}}
													visible={true}
													draggable={false}
												/>
											)
										}
									}
								)}
							</GoogleMapReact>
						</div>
					</div>
				</CardContent>
			</Card>
		)
	}
}
